


















































































































import { Component, Vue } from 'vue-property-decorator';
import BaseLayout from '@/layouts/BaseLayout.vue';
import {
  clientsModule, sandboxModule, sandboxLooksModule as looksModule, sandboxLooksModule,
} from '@/store';
import { CatalogItemShortDTO } from '@/api';
import CatalogItemPrice from '@/components/CatalogItemPrice.vue';
import BackgroundClipping from '@/components/BackgroundClipping.vue';
import CheckCard from '@/components/common/CheckCard.vue';
import LookDynamicCard from '@/components/looks/LookDynamicCard.vue';
import ThingTemperatureInput from '@/components/things/ThingTemperatureInput.vue';
import { getAssetUrl } from '@/utils';

@Component({
  name: 'sandbox-page',
  components: {
    BaseLayout,
    LookDynamicCard,
    CatalogItemPrice,
    CheckCard,
    ThingTemperatureInput,
    BackgroundClipping,
  },
})
export default class SandboxPage extends Vue {
  displayScreen: 'looks' | 'things' = 'things';

  loading = false;

  selectedThings: number[] = [];

  selectedLooks: number[] = [];

  multi = false;

  get client() {
    return clientsModule.model;
  }

  get sandboxThings() {
    return sandboxModule.sandboxThings;
  }

  get sandboxLooks() {
    return looksModule.groupedThingsByLook;
  }

  get things() {
    return this.sandboxThings.filter(i => this.selectedThings.includes(i.id));
  }

  get thing() {
    return this.things[this.things.length - 1];
  }

  get looks() {
    return this.sandboxLooks.filter(l => this.selectedLooks.includes(l.id as number));
  }

  get look() {
    return this.looks[this.looks.length - 1];
  }

  get lookTemperature() {
    return [Number(this.look?.temperatureFrom), Number(this.look?.temperatureTo)];
  }

  set lookTemperature(temperature: [number, number]) {
    this.saveTemperature(temperature);
  }

  get categories() {
    return looksModule.categories;
  }

  async created() {
    if (this.client?.id != null) {
      sandboxModule.fetchSandboxThings(this.client.id);
      await Promise.all([
        sandboxModule.fetchSandboxThings(this.client.id),
        looksModule.fetchLooks({ userId: this.client.id, status: 'SANDBOX' }),
        looksModule.fetchCategories(this.client.id),
      ]);
      if (this.sandboxThings[0]) {
        this.selectThing(this.sandboxThings[0].id as number);
      }
      if (this.looks[0]) {
        this.selectLook(this.looks[0].id as number);
      }
    }
  }

  selectThing(id: number) {
    if (this.multi) {
      const index = this.selectedThings.indexOf(id);
      if (index > -1) {
        this.selectedThings.splice(index, 1);
      } else {
        this.selectedThings.push(id);
      }
    } else {
      this.selectedThings = [id];
    }
  }

  selectLook(id: number) {
    if (this.multi) {
      const index = this.selectedLooks.indexOf(id);
      if (index > -1) {
        this.selectedLooks.splice(index, 1);
      } else {
        this.selectedLooks.push(id);
      }
    } else {
      this.selectedLooks = [id];
    }
  }

  async addToUserThings() {
    if (this.client?.id != null) {
      await sandboxModule
        .addToUserThings({ clientId: this.client.id, sandBoxItemIds: this.selectedThings });
    }
    this.selectedThings = [];
  }

  async addToUserLooks() {
    if (this.client?.id != null) {
      const { sandBoxLookIds: ids } = await sandboxModule
        .addToUserLooks({ clientId: this.client.id, sandBoxLookIds: this.selectedLooks });
      ids.forEach(id => sandboxLooksModule.removeLook(id));
    }
    this.selectedThings = [];
  }

  async deleteThing() {
    if (this.client?.id) {
      // eslint-disable-next-line no-await-in-loop
      await sandboxModule.deleteSandboxThings({
        clientId: this.client.id,
        items: this.things.map(thing => ({
          catalogItemId: thing.id,
          priceId: (thing.prices || [])[0].id,
        })),
      });
    }
    this.selectedThings = [];
  }

  async deleteLook() {
    // eslint-disable-next-line no-restricted-syntax
    for (const lookId of this.selectedLooks) {
      // eslint-disable-next-line no-await-in-loop
      await looksModule.deleteLook(lookId);
      this.selectedThings = [];
    }
  }

  handleAddButton(command: 'form' | 'catalog') {
    if (command === 'form') {
      this.$router.push({ name: 'catalog-add-to-sandbox' });
    }
    if (command === 'catalog') {
      this.$router.push({ name: 'sandbox-catalog' });
    }
  }

  async selectCategory(categoryId: number) {
    if (this.client && this.client.id != null) {
      // eslint-disable-next-line no-restricted-syntax
      for (const look of this.looks) {
        if (look && look.id != null) {
          const payload = {
            look: {
              ...look,
              category: categoryId,
              temperatureFrom: look.temperatureFrom ? String(look.temperatureFrom) : undefined,
              temperatureTo: look.temperatureFrom ? String(look.temperatureTo) : undefined,
            },
            userId: this.client.id,
            status: 'SANDBOX' as 'SANDBOX',
          };
          // eslint-disable-next-line no-await-in-loop
          await looksModule.saveLook(payload);
        }
      }
    }
  }

  async saveTemperature(temperature: [number, number]) {
    if (this.client && this.client.id != null) {
      // eslint-disable-next-line no-restricted-syntax
      for (const look of this.looks) {
        if (look && look.id != null) {
          const payload = {
            look: {
              ...look,
              category: Number(look.category),
              temperatureFrom: String(temperature[0]),
              temperatureTo: String(temperature[1]),
            },
            userId: this.client.id,
            status: 'SANDBOX' as 'SANDBOX',
          };
          // eslint-disable-next-line no-await-in-loop
          await looksModule.saveLook(payload);
        }
      }
    }
  }

  improveImage(imageUrl: string) {
    if (this.thing.id && this.client?.id != null) {
      sandboxModule.improveImage({ clientId: this.client.id, thingId: this.thing.id, imageUrl });
    }
  }

  resetSelected() {
    this.multi = false;
    if (this.thing?.id != null) {
      this.selectedThings = [this.thing.id];
    }
    if (this.look?.id != null) {
      this.selectedLooks = [this.look.id];
    }
  }

  getImage(item: CatalogItemShortDTO) {
    return item ? getAssetUrl(item.pictUrl) : null;
  }
}
